/**
 * PATCHED to support async css load
 */
define('mrg-smokescreen/StyleSheets', [
	'mrg-smokescreen/StyleSheets.Item',
	'mrg-smokescreen/StyleSheets.NativeParser',
	'mrg-smokescreen/Utils',
	'mrg-nano-xhr'
], function(StyleSheetsItem, StyleSheetsParser, Utils, xhr) {

    var RE_NORMALIZE = /(^(https?:)?\/\/[^/]+|\?timestamp=\d+$)/g;

    function normalizeLink(link) {
        return link.replace(RE_NORMALIZE, '');
    }

	function _convert(_selectors, selector) {
		var convertedSelector = _selectors(selector);

		return (convertedSelector !== selector ? convertedSelector + ',' : '') + selector;
	}

	function _propertiesToString(block) {
		var result = [];

		Utils.iterate(block, function (value, name) {
			result.push(name + ':' + value + ';');
		});

		return '{' + result.join('\n') + '}';
	}

	function _loadCSSByXhr(sheet) {
		var data = xhr.request({url: sheet.href, sync: true});
		if (data.error) {
			var message = '[CSS LOADING ERROR] Cant load ' + sheet.href;
			if (window.ajs && window.ajs.log) {
				window.ajs.log(message);
			}
			data.error.description = message;
			data.error.sheet = sheet;
			throw data.error;
		}
		return data.xhr.responseText;
	}

	function _awaitFor(links, callback) {

		var need = links.map(function(url) {
			return normalizeLink(url);
		});

		function _check() {
			Utils.iterate(document.styleSheets, function(sheet) {
				if(sheet.ownerNode.tagName === 'LINK') {
					var url = _getHref(sheet).replace(RE_NORMALIZE, '');

					need = need.filter(function(item) {
						return url !== item;
					});
				}
			});

			if(need.length) {
				setTimeout(_check, 100);

			} else {
				callback();
			}
		}

		_check();
	}

	function _getHref(sheet) {
		var href;

		if(sheet.ownerNode) {
			href = sheet.ownerNode.href || sheet.ownerNode.getAttribute('x-href');
			href = normalizeLink(href || '');
		}

		return href;
	}

    var _cssCache = {};

	function _loadCssByAsyncXhrAndCacheResult(links, callback, errorHook) {
	    if (Object.keys(_cssCache).length === links.length) {
            // all css files already loaded
            callback();
        }

        links.forEach(function(link) {
            xhr.request({url: link, sync: false}, function (error, request) {
                    if (error) {
                        errorHook(error);
                    }

                    if (request.readyState !== 4) return;

                    _cssCache[normalizeLink(link)] = request.responseText;

                    if (Object.keys(_cssCache).length === links.length) {
                        // all css files loaded
                        callback();
                    }
                });
        });

    }

	return {
		update: function(links, _selectors, options) {
            return new Promise(function(resolve, reject) {
                _awaitFor(links, function () {
                    // copy
                    var sheets = [].map.call(document.styleSheets, function (sheet) {
                        return sheet;
                    });

                    _loadCssByAsyncXhrAndCacheResult(links, function () {

                        sheets.forEach(function (sheet) {
                            if (!sheet.ownerNode || sheet.ownerNode.__created || sheet.__updated || sheet.ownerNode.tagName !== 'LINK') { // prevent possible recursion
                                return;
                            }

                            var origin = sheet;
                            sheet.__updated = true;

                            var href = _getHref(sheet);

                            // load proxy
                            if (href) {
                                try {
                                    var source = _cssCache[href];

                                    if (source) {
										var mediaText;
										try {
											if (sheet.media) {
												mediaText = sheet.media.mediaText;
											} else {
												mediaText = '';
											}
										} catch (e) {
											// в FF иногда почему-то не получается получить mediaText, валится ошибка
											mediaText = '';
										}

                                        var proxyStylesheet = new StyleSheetsItem({
                                            'x-href': href,
                                            'media': mediaText
                                        }, sheet.ownerNode);

                                        proxyStylesheet.setContent(source);
                                        proxyStylesheet.apply();

                                        origin = proxyStylesheet.getSheet();
                                        origin.__updated = true;

                                        var nextSheet = new StyleSheetsItem({
                                            'x-href': href,
                                            'media': mediaText

                                        }, origin.ownerNode);

                                        nextSheet.__updated = true;

                                        StyleSheetsParser.iterate(origin, _convert.bind(null, _selectors), href, function (rule) {
                                            nextSheet.insert(rule.toString());
                                        }, options);

                                        nextSheet.apply();
                                    }
                                } catch (err) {
                                    reject(err);
                                }
                            }
                        });
                        resolve();
                    }, function (error) {
                        reject(error);
                    });
                });
            });
		},

		remove: function(links) {
			links = (links || []).map(function(url) {
				return (url || '').replace(/^https:/, '');
			});

			if(links.length) {
				var toRemove = [];
				Utils.iterate(document.styleSheets, function(sheet) {
					var url = _getHref(sheet);

					if(url && links.indexOf(url) !== -1) {
						toRemove.push(sheet);
					}
				});

				for(var i = toRemove.length - 1; i >=0; i--) {
					var sheet = toRemove[i];
					sheet.ownerNode.parentNode.removeChild(sheet.ownerNode);
				}
			}
		},

		insert: function(config, _selectors) {
			var sheet = new StyleSheetsItem({});
			var _bindConvert = _convert.bind(null, _selectors);
			var constructRule = function (selector, block ) {
				return _bindConvert(selector) + _propertiesToString(block);
			};

			var insertRule = function(block, selector) {
				// Содержит блочные @-rule? Итерируемся по вложенному объекту
				if (/@(media|supports|document|page|keyframes|font-feature-values)/.test(selector)) {
					var blockRules = [];
					var createBlockRule = function (block, selector) {
						blockRules.push(constructRule(selector, block));
					};

					Utils.iterate(block, createBlockRule);

					sheet.insertBlock(selector, blockRules.join(''));
				} else {
					sheet.insert(constructRule(selector, block));
				}
			};

			Utils.iterate(config, insertRule);

			sheet.apply();
		}
	}
});
